import { getCookie } from "./cookieFunction";
import axios from 'axios';

export const handledoit = async (appState, id,subscriptionData) => {
  try {
    const customPayload = {
      endpoint: subscriptionData?.endpoint,
      invoice_id: id,
      keys: subscriptionData?.keys,
    };

    const response = await axios.post(`${process.env.REACT_APP_API_URL}webpush/add`, customPayload, {
      headers: {
        Authorization: `Bearer ${getCookie("tokenAuth")}`,
        'Content-type': 'application/json',
        'X-Parse-Application-Id': 'jAYHoiZ5DHT513oUijFk3nAZZkd3ZR8O7RB1wfkH',
        'X-Parse-REST-API-Key': 'paoCXOhbtEXcMcHkKfs9',
      },
    });

  } catch (error) {
  }
};



export const handleRunServiceWorker = async (appState, appDispatch,id) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      let subscriptionData = JSON.parse(JSON.stringify(subscription));
      localStorage.setItem(`service_worker_${appState?.storeInfo?.slug}`, JSON.stringify(Boolean(subscription)))
      handledoit(appState,id,subscriptionData)
    } else {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}webpush/key`, {});
      const responseData = response.data;
      const vapidKey = responseData.key;
      const convertedVapidKey = urlBase64ToUint8Array(vapidKey);

      const newSubscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedVapidKey
      });
      let subscriptionData = JSON.parse(JSON.stringify(newSubscription));
      localStorage.setItem(`service_worker_${appState?.storeInfo?.slug}`, JSON.stringify(Boolean(newSubscription)))
      handledoit(appState,id,subscriptionData)
    }
  } catch (error) {
  }
};
function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}


export const handleSendNotificaiton = async (appState, appDispatch) => {
  try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/webpush/send`, {
        endpoint: appState?.pushSubscription?.endpoint,
        keys: appState?.pushSubscription?.keys,
      })

      // console.log("subscription else", JSON.parse(JSON.stringify(newSubscription)))
  } catch (error) {
    
  }
}